$('select[name="cboUserId"]').on('change', function () {
    window.location = base_url + 'admin/reporting/student-feedback/' + $(this).val();
});
